<template>
    <div style="padding: 0 10px">
        <div class="add-title">基本信息</div>
        <Form :model="formItem" :label-width="100" ref="formItem" :rules="rules">
            <Row>
                <Col span="8">
                    <FormItem label="项目代码" prop="code" class="my-form-item">
                        <Input v-model="formItem.code" placeholder="请输入项目代码"></Input>
                    </FormItem>
                </Col>
                <Col span="8">
                    <FormItem label="项目名称" prop="name" class="my-form-item">
                        <Input v-model="formItem.name" placeholder="请输入项目名称"></Input>
                    </FormItem>
                </Col>
                <Col span="8">
                    <FormItem label="所属分类" prop="classifyId" class="my-form-item">
                        <Select v-model="formItem.classifyId" filterable>
                            <Option v-for="item in classifyList" :value="item.id + ''" :key="item.id">{{ item.name }}</Option>
                        </Select>
                    </FormItem>
                </Col>
            </Row>
            <Row>
                <Col span="8" v-if="merchantInfo.merchantType === 1">
                    <FormItem label="计价方式" prop="priceMethod" class="my-form-item">
                        <RadioGroup v-model="priceMethodModel" @on-change="methodChange">
                            <Radio label="工时计价" style="margin-left: 10px" :true-value="1"></Radio>
                            <Radio label="金额计价" style="margin-left: 5px"></Radio>
                        </RadioGroup>
                    </FormItem>
                </Col>
                <Col span="8" v-if="priceMethodModel === '工时计价'">
                    <FormItem label="工时(小时)" prop="preManhour" class="my-form-item">
                        <Input type="number" v-model="formItem.preManhour" placeholder="请输入预估工时"></Input>
                    </FormItem>
                </Col>
                <Col span="8" v-if="priceMethodModel === '工时计价'">
                    <FormItem label="单价(元/小时)" prop="unitPrice" class="my-form-item">
                        <Input type="number" v-model="formItem.unitPrice" placeholder="请输入工时单价"></Input>
                    </FormItem>
                </Col>
                <Col span="8" v-if="priceMethodModel === '金额计价'">
                    <FormItem label="项目价格(元)" prop="totalPrice" class="my-form-item">
                        <Input type="number" v-model="formItem.totalPrice" placeholder="请输入项目价格"></Input>
                    </FormItem>
                </Col>
            </Row>
            <FormItem label="备注" prop="remark" class="my-form-item">
                <Input type="textarea" v-model="formItem.remark"
                       placeholder="请输入备注" maxlength="500" show-word-limit></Input>
            </FormItem>
        </Form>
        <div class="add-title" style="padding: 10px 0">
            <Row>
                <Col span="12" style="text-align: left">
                    材料信息
                </Col>
                <Col span="12" style="text-align: right">
                    <Button size="small" style="margin-right: 15px" @click="resetMaterials">重置材料</Button>
                    <Button size="small" type="primary" style="margin-right: 12px"
                            @click="showSelectMaterModal">选择材料
                    </Button>
                </Col>
            </Row>
        </div>
        <div class="table-container">
            <Table border size="small" :columns="materColumns" :data="selectedMaterList">
                <template #action="{ row, index }">
                    <Button class="table-button-remove" size="small" @click="removeSelectedMater(row)">删除</Button>
                </template>
                <template #count="{row, index}">
                    <Input type="number" v-model="row.count"
                           @on-keypress="onCountInputKeyPress"
                           @input="(value) => updateCount(index, value)"/>
                </template>
            </Table>
        </div>
        <div style="text-align: right;margin-top: 10px">
            <Button style="margin-right: 10px" type="primary" :loading="loading" icon="md-checkmark" @click="handleOk">确定</Button>
            <Button @click="handleCancel" icon="ios-undo">取消</Button>
        </div>
        <Modal
            fullscreen
            v-model="showMaterSelect"
            :closable="false"
            footer-hide>
            <div>
                <choose-mater v-if="showMaterSelect" @handleClose="handleChooseClose"></choose-mater>
            </div>
        </Modal>
    </div>
</template>

<script>
import {queryItemClassifyList, queryMaterialsByItem, saveItemInfo} from "@/api/baseData"
import ChooseMater from "@/components/BaseData/ChooseMater"

export default {
    name: "NewItem",
    components: {
        ChooseMater,
    },
    props: {
        itemInfo: {
            type: Object,
        },
    },
    data() {
        return {
            formItem: {
                name: '',
                code: '',
                classifyId: '',
                priceMethod: 1,
                preManhour: '',
                unitPrice: '',
                totalPrice: '',
                remark: '',
            },
            rules: {
                name: [
                    {required: true, message: '项目名称不能为空', trigger: 'blur'},
                ],
                classifyId: [
                    {required: true, message: '所属分类不能为空', trigger: 'blur'},
                ],
            },
            materColumns: [
                {
                    title: '材料名称',
                    key: 'name',
                    align: 'left',
                    width: 120,
                },
                {
                    title: '所属目录',
                    key: 'catalogName',
                    align: 'center',
                },
                {
                    title: '单位',
                    key: 'unitName',
                    align: 'center',
                },
                {
                    title: '规格',
                    key: 'matSpec',
                    align: 'center',
                },
                {
                    title: '数量',
                    slot: 'count',
                    width: 160,
                    align: 'center',
                },
                {
                    title: '操作',
                    slot: 'action',
                    width: 160,
                    align: 'center',
                },
            ],
            classifyList: [],
            selectedMaterList: [],
            priceMethodModel: '',
            loading: false,
            showMaterSelect: false,
            merchantInfo: {},
        }
    },
    mounted() {
        if (this.itemInfo.id) {
            this.formItem = Object.assign({}, this.itemInfo)
            if (this.formItem.priceMethod === 1) {
                this.priceMethodModel = '工时计价'
            } else {
                this.priceMethodModel = '金额计价'
            }
            queryMaterialsByItem({itemId: this.formItem.id}).then((res) => {
                this.selectedMaterList = res.data
            })
        }
        this.initInfo()
    },
    methods: {
        initInfo() {
            this.merchantInfo = JSON.parse(sessionStorage.getItem('merchantInfo'))
            if (this.merchantInfo.merchantType !== 1) {
                this.priceMethodModel = '金额计价'
                this.formItem.priceMethod = 2
            } else {
                this.priceMethodModel = '工时计价'
                this.formItem.priceMethod = 1
            }
            queryItemClassifyList({}).then((res) => {
                this.classifyList = res.data
            })
        },
        resetMaterials() {
            this.selectedMaterList = []
        },
        showSelectMaterModal() {
            this.showMaterSelect = true
        },
        removeSelectedMater(row) {
            this.selectedMaterList = this.selectedMaterList.filter(item => item.id !== row.id)
        },
        onCountInputKeyPress(event) {
            if (event.key !== 'Backspace' && !/[0-9]/.test(event.key)) {
                event.preventDefault()
            }
        },
        updateCount(index, value) {
            this.$set(this.selectedMaterList, index, {
                ...this.selectedMaterList[index],
                count: Number(value),
            })
        },
        handleOk() {
            this.loading = true
            this.$refs.formItem.validate((valid) => {
                if (valid) {
                    let imList = []
                    // eslint-disable-next-line no-restricted-syntax
                    for (let item of this.selectedMaterList) {
                        let imObj = {
                            count: item.count,
                            materialsId: item.id,
                        }
                        imList.push(imObj)
                    }
                    let param = {
                        itemInfo: this.formItem,
                        itemMaterialsList: imList,
                    }
                    saveItemInfo(param).then(() => {
                        this.$emit('handleClose', true)
                    }).finally(() => {
                        this.loading = false
                    })
                } else {
                    this.loading = false
                }
            })
        },
        handleCancel() {
            this.$emit('handleClose', false)
        },
        methodChange(label) {
            if (label === '工时计价') {
                this.formItem.priceMethod = 1
            } else {
                this.formItem.priceMethod = 2
            }
        },
        handleChooseClose(data) {
            if (data) {
                // eslint-disable-next-line no-restricted-syntax
                for (let item of data) {
                    if (!this.isExist(this.selectedMaterList, item)) {
                        item.count = 1
                        this.selectedMaterList.push(Object.assign({}, item))
                    }
                }
            }
            this.showMaterSelect = false
        },
        isExist(list, data) {
            // eslint-disable-next-line no-restricted-syntax
            for (let item of list) {
                if (item.id === data.id) {
                    return true
                }
            }
            return false
        },
    },
}
</script>

<style scoped>
.my-form-item {
    margin-left: 20px;
}

.add-title {
    font-size: 16px;
    font-weight: bold;
    background: #f3f7fd;
    padding: 5px 0;
    margin-bottom: 10px;
}

.add-title div {
    font-size: 16px;
}
</style>
